import React from 'react';
import {Notification} from '@bosch/react-frok';
import {Wrapper} from './ErrorHint.style';
import {NotificationType} from '../../models/NotificationType';

export interface ErrorHintProps {
    readonly type: NotificationType;
    readonly message: string;
}

/**
 * @name ErrorHint
 * @description Generic failure and hint visualisation component
 */
export const ErrorHint: React.VFC<ErrorHintProps> = (props) => {
    const iconName = () => {
        switch (props.type) {
            case NotificationType.ERROR:
                return 'alert-error';
            case NotificationType.WARNING:
                return 'alert-warning';
            case NotificationType.INFO:
            default:
                return 'alert-info';
        }
    };

    return (
        <Wrapper>
            <Notification icon={iconName()}
                          type={props.type}
                          content={props.message}/>
        </Wrapper>
    );
};
